import GeoAutocomplete from './components/GeoAutocomplete';
import Waiting from './components/Waiting';
import ErrorSign from './components/ErrorSign';

// validation/
import ValidationMap from './components/validation/ValidationMap';

// details/
import BarChart from './components/details/BarChart';
import ThumbsChart from './components/details/ThumbsChart';
import MSPieChart from './components/details/MSPieChart';
import PhotoChart from './components/details/PhotoChart';

// admin/
// import ConfigureAggregations from './components/admin/segmentWizard/ConfigureAggregations';
import ConfigureAggregationsV2 from './components/admin/segmentWizard/ConfigureAggregationsV2';
import SWSelectForm from './components/admin/segmentWizard/steps/SelectForm';
import SWSortInputs from './components/admin/segmentWizard/steps/SortInputs';
import SWReview from './components/admin/segmentWizard/steps/Review';
import SWReduceAnswers from './components/admin/segmentWizard/steps/ReduceAnswers';
import SWDivideForm from './components/admin/segmentWizard/steps/DivideForm';
import SWMapQuestions from './components/admin/segmentWizard/steps/MapQuestions';
import SWCreateAggregation from './components/admin/segmentWizard/steps/CreateAggregation';
import GroupTable from './components/admin/GroupTable';
import FormTable from './components/admin/FormTable';
import GenericTable from './components/GenericTable';
import AnchorGeoTable from './components/admin/AnchorGeoTable';
import ColorScaleSelector from './components/sentiment/ColorScaleSelector';
import ColorCanvas from './components/sentiment/ColorCanvas';
import ColorRamps from './common/ramps';
import * as common from './common.js';

if (!String.prototype.hashCode) {
  // eslint-disable-next-line no-extend-native
  String.prototype.hashCode = function () {
    let hash = 0,
      i,
      chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
      chr = this.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  };
}

export {
  AnchorGeoTable,
  BarChart,
  ColorScaleSelector,
  ColorRamps,
  ColorCanvas,
  common,
  ConfigureAggregationsV2,
  ErrorSign,
  FormTable,
  GenericTable,
  GeoAutocomplete,
  GroupTable,
  MSPieChart,
  PhotoChart,
  SWSelectForm,
  SWCreateAggregation,
  SWDivideForm,
  SWMapQuestions,
  SWReduceAnswers,
  SWReview,
  SWSortInputs,
  ThumbsChart,
  ValidationMap,
  Waiting
};
